import { TranslatePipe } from '@myre/ui-primitive-core';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FooterItem } from '../footer-item.component';

@Component({
  selector: 'myre-footer-text',
  templateUrl: './footer-text.component.html',
  styleUrls: [
    '../../footer-item.component.scss',
    './footer-text.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class FooterTextComponent extends FooterItem {
  @Input()
  public redirectUrl: string | string[];

  @Input()
  public value: string;
}
